import {z} from 'zod';

export const LeasingOneTimeItemKindSchema = z.enum([
  'VEHICLE_TRANSFER',
  'VEHICLE_REGISTRATION',
  'VEHICLE_DELIVERY',
]);
export type LeasingOneTimeItemKind = z.infer<typeof LeasingOneTimeItemKindSchema>;
